
const NotFound = () => {
  return (
    <div>
      Notfound
    </div>
  )
}

export default NotFound
